import { useQuery } from '@tanstack/react-query'
import { serversApi } from '../../infrastructure/api'

export const useServerDetails = (serverId: string) => {
  return useQuery({
    queryKey: ['server-details', serverId],
    queryFn: () => serversApi.getServerById(serverId),
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: 2,
  })
}
